interface ShareTokenState {
  token: string | null;
  isValid: boolean;
  error: string | null;
}

export const useShareToken = (): ShareTokenState => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("share_token");

  if (!token) {
    return {
      token: null,
      isValid: false,
      error: "No share token provided",
    };
  }

  if (token.trim().length === 0) {
    return {
      token: null,
      isValid: false,
      error: "Invalid share token",
    };
  }

  return {
    token,
    isValid: true,
    error: null,
  };
};
